<div>
  <mic-breadcrumb id="inventory-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/inventory" label="{{ translationService.translate('inventoryText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate(selectedTabLabel) }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <form>
    <h2 class="page-title" id="inventory-heading">{{ translationService.translate(selectedTabLabel) }}</h2>

    <mat-tab-group id="tabs" mat-stretch-tabs="false" (selectedIndexChange)="onTabChange($event)">
      <mat-tab id="stock-movement-tab" label="{{ translationService.translate('stockMovementHistoryText') }}">
        <app-stock-movement-history></app-stock-movement-history>
      </mat-tab>
      <mat-tab id="stock-management-tab" label="{{ translationService.translate('stockManagementText') }}">
        <app-stock-management></app-stock-management>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
